module.exports = __webpack_public_path__ + "img/SF@2x.d88bb9ed.png";